import dayjs from 'dayjs';
import { IBasket } from 'models/basket.model';
import { BasketOrder } from 'models/basket-order.model';
import { ITransporterMember } from 'models/transporter-member.model';
import { Transporter } from 'models/transporter.model';
import { User } from './user.model';
import { UserTypology } from './enums/user-typology.model';
import { PaymentPeriod } from './enums/payment-period.enum';

export interface ICustomer {
  id?: number;
  userTypology?: UserTypology | null;
  paymentPeriod?: PaymentPeriod | null;
  marginRate?: number | null;
  sepaAlias?: string | null;
  accountingCode?: string | null;
  acceptedCGV?: boolean | null;
  transporterAlias?: string | null;
  paymentDelay?: number | null;
  creationDate?: dayjs.Dayjs | null;
  commentTransporter?: string | null;
  basket?: IBasket | null;
  currentBasketOrder?: BasketOrder | null;
  transporterMember?: ITransporterMember | null;
  transporter?: Transporter;
  user: User;
}

export class Customer implements ICustomer {
  public user!: User;
  public id?: number;
  public userTypology?: UserTypology | null;
  public paymentPeriod?: PaymentPeriod | null;
  public marginRate?: number | null;
  public sepaAlias?: string | null;
  public accountingCode?: string | null;
  public acceptedCGV: boolean | null = false;
  public transporterAlias?: string | null;
  public paymentDelay?: number | null;
  public creationDate?: dayjs.Dayjs | null;
  public commentTransporter?: string | null;
  public basket?: IBasket | null;
  public currentBasketOrder?: BasketOrder | null;
  public transporterMember?: ITransporterMember | null;
  public transporter?: Transporter;
}

export function getCustomerIdentifier(customer: ICustomer): number | undefined {
  return customer.id;
}
